import type { ProfileManagementMode } from './ProfileCredentialIntegrations';

export type EmployeeDocumentsProfileMode = 'admin' | 'self' | null;

interface EmployeeDocumentsAccessInput {
  featureEnabled: boolean;
  managementMode: ProfileManagementMode;
  isAdminView: boolean;
  isOwnProfile: boolean;
  actorRoles: readonly string[] | null | undefined;
}

export function resolveEmployeeDocumentsProfileMode({
  featureEnabled,
  managementMode,
  isAdminView,
  isOwnProfile,
  actorRoles
}: EmployeeDocumentsAccessInput): EmployeeDocumentsProfileMode {
  if (!featureEnabled || managementMode === 'partner_delegated') {
    return null;
  }

  const hasLiteralAdminRole = actorRoles?.some(
    role => role.trim().toLowerCase() === 'admin'
  ) === true;
  if ((managementMode === 'admin' || isAdminView) && hasLiteralAdminRole) {
    return 'admin';
  }

  if (managementMode === 'self' && isOwnProfile) {
    return 'self';
  }

  return null;
}
